export const routes = (id) => {
  const links = [
    { text: 'Overview', value: `/users/${id}/` },
    { text: 'Activities', value: `/users/${id}/activities/` },
  ];
  return links;
};



// WEBPACK FOOTER //
// ./src/containers/Staffs/navigations.js